export const getNavBarClass = (isMobile, pathname) => {
  const isHomePage = pathname === "/";
  const isProjectPage =
    pathname?.includes("/projects/") || pathname?.includes("/project/");
  const isTeamPage = pathname?.includes("/team");
  const isJournalHomePage =
    pathname === "/journals" || pathname === "/journals/";

  if (isTeamPage || isJournalHomePage) return "sand-bkgd-colour";

  if (isHomePage) return "transparent-bkgd";

  if (isProjectPage && !isMobile) return "transparent-bkgd";

  return "white-bkgd";
};
